import { createAction } from '@reduxjs/toolkit'
import { ActionTypes_Settings } from './TActions'
import { TSettings } from './TReducer'
import { TStoreTemplate } from 'redux/config/root-types'

const { StoreActions } = ActionTypes_Settings

export const Actions_Settings = {
  saga: {},

  store: {
    showLoader: createAction(StoreActions.IS_LOADER_SHOW),
    hideLoader: createAction(StoreActions.IS_LOADER_HIDE),
    saveSettings: createAction<TStoreTemplate<TSettings>>(StoreActions.SAVE_SETTINGS),
  },
}
